import axios from 'axios';

import { SpotifyUser, SpotifyArtist } from './spotifyClient.types';

export const spotifyClient = (token: string) => {
  const baseUrl = 'https://api.spotify.com/v1/me';
  const base = 'https://api.spotify.com/v1';

  const instance = axios.create({
    headers: {
      Authorization: `Bearer ${token}`,
      'content-type': 'application/json',
    },
  });

  const getCache = async (url: string, cache?: boolean) => {
    if (!cache) {
      return instance.get(url);
    }

    const key = `${token}:${url}`;

    const cached = localStorage.getItem(key);
    if (cached) {
      return JSON.parse(cached);
    }

    const result = await instance.get(url);

    localStorage.setItem(key, JSON.stringify(result));

    return result;
  };

  return {
    async searchArtist(artistName: string, type: 'artist') {
      const url = `${base}/search?q=${artistName}&type=${type}`;
      try {
        const result = await getCache(
          url,
          process.env.NODE_ENV === 'development'
        );

        return result.data.artists.items;
      } catch (error) {
        throw error;
      }
    },
    async relatedArtists(artistId: string) {
      const url = `${base}/artists/${artistId}/related-artists`;
      try {
        const result = await getCache(
          url,
          process.env.NODE_ENV === 'development'
        );

        return result.data.artists;
      } catch (error) {
        throw error;
      }
    },
    async me(): Promise<SpotifyUser> {
      try {
        const result = await getCache(
          baseUrl,
          process.env.NODE_ENV === 'development'
        );

        return result.data;
      } catch (error) {
        throw error;
      }
    },
    async top(
      type: 'artists' | 'tracks',
      timeRange: 'short_term' | 'medium_term' | 'long_term' = 'medium_term'
    ): Promise<SpotifyArtist[]> {
      const url = `${baseUrl}/top/${type}?limit=50&time_range=${timeRange}`;
      try {
        const result = await getCache(
          url,
          process.env.NODE_ENV === 'development'
        );

        return result.data.items;
      } catch (error) {
        throw error;
      }
    },
  };
};

export default spotifyClient;
